<template>
<div class="tela-vantagem container">
  <div v-if="activeCategory == null">
    <BannerSlideVantagens :banners="vantagensSlider" />
    <div v-if="categories.length" class="categoria-vantagem">
      <h2>{{ t('ESCOLHA_POR_CATEGORIA') }}</h2>
      <div>
        <a v-for="(category, index) of categories" v-on:click="setCategory(category)" v-bind:key="index">
          <img :src="category.icon ? category.icon.imageUrl : '/img/vantagens.b2d1b203.svg'" :alt="category.title">
          <strong>{{ category.title }}</strong>
        </a>
      </div>
    </div>
    <div v-if="partners.length">
      <h2>{{ t('DESTAQUE') }}</h2>
      <VantagensShowcase v-for="(partners, index) of partners" :partners="partners" v-bind:key="index"/>
    </div>
  </div>
  <div v-if="activeCategory !== null">
    <v-app>
      <v-card elevation="0" v-if="activeCategory.desktop ||activeCategory.mobile" class="img-banner">
        <img v-if="activeCategory.desktop && !isMobile()" :src="activeCategory.desktop.imageUrl" alt="">
        <img v-if="activeCategory.mobile && isMobile()" :src="activeCategory.mobile.imageUrl" alt="">
      </v-card>
    </v-app>
    <a v-on:click="setCategory(null)" class="margindefault back">{{ t('VOLTAR') }}</a>
    <h2>{{ activeCategory.title }}</h2>
    <div v-if="activePartners.length">
      <VantagensShowcase :partners="activePartners"/>
    </div>
    <div v-else>
      <p v-if="!loading"  class="margindefault">{{ t('NENHUM_PARCEIRO_CATEGORIA') }}</p>
      <p v-else  class="margindefault">{{ t('CARREGANDO') }}</p>
    </div>
  </div>
</div>
</template>
<style lang="scss">
.back { cursor: pointer; }
.img-banner img { width: 100% }
  .margindefault { margin: 2%;     display: inline-block; }
  .tela-vantagem.container { padding-top: 15px;}
  .tela-vantagem h2 { color: #7c7f81; font-weight: bold; margin: 2% 2% 0 2% }
   .categoria-vantagem {
     div {
      display: flex;
      flex-wrap: wrap;
      img {
        width: 130px;
        margin-bottom: 20px;
      }
      a {
        cursor: pointer;
        width: 25%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #7c7f81;
        font-weight: normal;
        padding: 10px 20px;
      }
    }
   }
   @media(max-width: 992px) {
     
     .margindefault { margin: 15px }
    .tela-vantagem h2 { margin: 15px }
    .categoria-vantagem {
      div {
        width: 90%;
        margin: 0 auto;
        a {
          width: 50%;
        }
        img {
          width: 80%;
        }
      }
    }
   }
</style>

<script>
import{ VCard, VApp } from 'vuetify/lib';
import { translate } from '../services/translate.service';
import { isMobile, resolvePromise } from '../helpers/helpers'
import {getPartnersSpotlight} from '../services/partner.service.js'
import {getPartnerCategories, getById } from '../services/partnerCategory.service.js'
import VantagensShowcase from '@/components/VantagensShowcase.vue'
import { baseURL } from '../config/http';
import { get } from '../services/image.service'
import BannerSlideVantagens from '@/components/BannerSlideVantagens.vue'
export default {
  name: 'vantagens',
  data(){
    return{
      categories:[],
      partners:[],
      activePartners: [],
      activeCategory: null,
      loading: false,
      vantagensSlider: []
    }
  },
  components: {
    VantagensShowcase,
    BannerSlideVantagens,
    VCard,
    VApp
  },
  methods:{
    isMobile,
    t:translate,
    setCategory(category){
      if(category) {
        this.activePartners = [];
        this.activeCategory = category;
        this.$router.push({query: { c: category.title }})
        this.loading=true;
        resolvePromise(getById(category.id, {complete: true}),({data})=>{
          this.activePartners = (data.partners || []).sort((a, b) => a.orderSite - b.orderSite).map((v) => {
            if(v.banner) v.banner.imageUrl = baseURL + v.banner.imageUrl.replace(/\\/gm,'/');
            return v;
          });
          this.loading = false;
        }, console.error, this);
      } else {
        this.activeCategory = null;
        this.$router.push({query: {}});
      }
    }
  },
  created(){
    get("Vantagens").then(r => {
      this.vantagensSlider = r.data
        .filter((v) => v.culture == 'pt').map((v) => {
          v.desktop.imageUrl = baseURL + v.desktop.imageUrl.replace(/\\/gm,'/');
          v.mobile.imageUrl = baseURL + v.mobile.imageUrl.replace(/\\/gm,'/');
          return v
        })
        .sort((a, b) => a.position - b.position)
    });
    resolvePromise(getPartnerCategories(),({data})=>{
      this.categories = data.items.map((v) => {
        if(v.icon) v.icon.imageUrl = baseURL + v.icon.imageUrl.replace(/\\/gm,'/');
        if(v.desktop) v.desktop.imageUrl = baseURL + v.desktop.imageUrl.replace(/\\/gm,'/');
        if(v.mobile) v.mobile.imageUrl = baseURL + v.mobile.imageUrl.replace(/\\/gm,'/');
        return v;
      });
      if(this.$route.query.c) {
        this.categories.filter((v, k) => {
          console.log(v.title, this.$route.query.c);
          if(v.title == this.$route.query.c) {
            this.setCategory(v);
          }
        })
      }
    },console.error,this);
    resolvePromise(getPartnersSpotlight(),({data})=>{
      this.partners.push(data.map((v) => {
        console.log('destaque', v);
        if(v.banner) v.banner.imageUrl = baseURL + v.banner.imageUrl.replace(/\\/gm,'/');
        return v;
      }));
    },console.error,this);
  }
}
</script>
